import { type ReactNode } from 'react';

export type TabItem = { label: string; content: ReactNode };

export const when = (condition: unknown, item: TabItem): TabItem | null => (condition ? item : null);

export const visibleTabs = (items: (TabItem | null)[]): TabItem[] =>
  items.filter((item): item is TabItem => item !== null);
